import { FC, PropsWithChildren } from "react";

export const DialogChildren: FC<PropsWithChildren> = ({ children }) => {
  if (!children) { return null; }
  return (
    <div data-component="DialogChildren">
      { children }
    </div>
  );
};
